// removed by extract-text-webpack-plugin
module.exports = {"blink":"src-components----Text-module---blink---VMRJ8","large":"src-components----Text-module---large---2Paw9","medium":"src-components----Text-module---medium---1LLLw","small":"src-components----Text-module---small---1_q41","micro":"src-components----Text-module---micro---3woZp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Text.module.css
// module id = 136
// module chunks = 35783957827783 43201937662106